import { render, staticRenderFns } from "./auth-token.component.vue?vue&type=template&id=52d44d87&"
import script from "./auth-token.component.vue?vue&type=script&lang=ts&"
export * from "./auth-token.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports